import { KeyValue } from '@angular/common';

export function generateSelectableDatesKeyValueFrom(start: number): KeyValue<number, number>[] {
  const selectableYears: KeyValue<number, number>[] = [];
  const now = new Date();

  for (let i = start; i <= now.getFullYear(); i++) {
    selectableYears.push({
      key: i,
      value: i,
    });
  }
  return selectableYears;
}

export function generateSelectableAvailablePaymentInstallmentsKeyValue(
  durationInMonths: number
): KeyValue<number, number>[] {
  const selectableAvailablePaymentInstallments: KeyValue<number, number>[] = [];
  const existingInstallments = [3, 6];

  existingInstallments.forEach((existingInstallment) => {
    if (durationInMonths >= existingInstallment) {
      selectableAvailablePaymentInstallments.push({
        key: existingInstallment,
        value: existingInstallment,
      });
    }
  });

  return selectableAvailablePaymentInstallments;
}
